// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNavView-cls1_zSS","cls2":"FocusedNavView-cls2_iSO FocusedNavView-cls1_zSS"};